import type { ThunkDispatch, UnknownAction } from "@reduxjs/toolkit";
import { useDispatch, useSelector, type TypedUseSelectorHook } from "react-redux";
import type { TeamsState } from "./teams.slice";

/**
 * Deliberately local, narrow typing (just this module's own slice) rather
 * than importing the app-wide `RootState`/`AppDispatch` from `@vv/state`
 * - that package composes the real store by importing this module's reducer,
 * so importing back from here would be a circular workspace dependency.
 * Safe at runtime: these hooks read from whatever store is actually in
 * context, which always includes a `teams` slice once `apps/web` registers it.
 */
interface TeamsModuleState {
  teams: TeamsState;
}

type TeamsModuleDispatch = ThunkDispatch<TeamsModuleState, unknown, UnknownAction>;

export const useTeamsDispatch = () => useDispatch<TeamsModuleDispatch>();
export const useTeamsSelector: TypedUseSelectorHook<TeamsModuleState> = useSelector;
